module.exports = __webpack_public_path__ + "static/media/coming.37ade1b6.svg";